var React = require('react');

function SesTemplateImport (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"#064861","key":0}),React.createElement("mask",{"id":"mask0_5595_2148","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"12","y":"12","width":"24","height":"24","key":1},React.createElement("rect",{"x":"12","y":"12","width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5595_2148)","key":2},React.createElement("path",{"d":"M24 28L19 23L20.4 21.55L23 24.15V16H25V24.15L27.6 21.55L29 23L24 28ZM18 32C17.45 32 16.9792 31.8042 16.5875 31.4125C16.1958 31.0208 16 30.55 16 30V27H18V30H30V27H32V30C32 30.55 31.8042 31.0208 31.4125 31.4125C31.0208 31.8042 30.55 32 30 32H18Z","fill":"#FFD301"}))]);
}

SesTemplateImport.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = SesTemplateImport;

SesTemplateImport.default = SesTemplateImport;
